/* Keep Shopify's original variant IDs and change handler as the source of truth. */
(() => {
  function init(scope = document) {
    const picker = scope.querySelector('[data-variant-picker]');
    if (!picker || picker.dataset.ready) return;
    const form = picker.closest('form');
    const native = form.querySelector('[data-variant-select]');
    const data = scope.querySelector('[data-product-variants]');
    if (!native || !data) return;
    let variants, labels;
    try {
      variants = JSON.parse(data.textContent);
      labels = JSON.parse(picker.querySelector('[data-picker-labels]').textContent);
    } catch { return; }
    // Unknown formats keep the original selector, including subscriptions and bundles.
    const rows = variants.map(v => {
      const match = /^(ESD|USB|DVD)(?:\s+(32|64)(?:\s*-\s*|\s+)bits?)?\s*\|\s*(DE|EN|IT|FR|DE, EN, IT, FR)$/i.exec(v.title.trim());
      if (!match) return null;
      return { id: String(v.id), delivery: match[1].toUpperCase(), architecture: match[2] || '', language: match[3].includes(',') ? 'MULTI' : match[3].toUpperCase() };
    });
    if (!rows.length || rows.some(r => !r)) return;
    const signatures = rows.map(r => [r.delivery, r.language, r.architecture].join('|'));
    if (new Set(signatures).size !== rows.length) return;
    const delivery = picker.querySelector('[data-picker-delivery]');
    const language = picker.querySelector('[data-picker-language]');
    const architecture = picker.querySelector('[data-picker-architecture]');
    const architectureWrap = picker.querySelector('[data-picker-architecture-wrap]');
    function options(select, values, preferred) {
      select.replaceChildren(...[...new Set(values)].map(value => new Option(labels[value] || (value ? value + '-Bit' : '—'), value)));
      select.value = values.includes(preferred) ? preferred : values[0];
    }
    function render(row) {
      options(delivery, rows.map(r => r.delivery), row.delivery);
      const formats = rows.filter(r => r.delivery === delivery.value);
      options(language, formats.map(r => r.language), row.language);
      const languages = formats.filter(r => r.language === language.value);
      options(architecture, languages.map(r => r.architecture), row.architecture);
      architectureWrap.hidden = !languages.some(r => r.architecture);
    }
    function change() {
      let candidates = rows.filter(r => r.delivery === delivery.value);
      const sameLanguage = candidates.filter(r => r.language === language.value);
      if (sameLanguage.length) candidates = sameLanguage;
      const sameArchitecture = candidates.filter(r => r.architecture === architecture.value);
      if (sameArchitecture.length) candidates = sameArchitecture;
      const row = candidates[0];
      if (!row) return;
      render(row);
      native.value = row.id;
      native.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const selected = rows.find(r => r.id === native.value);
    if (!selected) return;
    render(selected);
    [delivery, language, architecture].forEach(s => s.addEventListener('change', change));
    native.addEventListener('change', () => {
      const row = rows.find(r => r.id === native.value);
      if (row) render(row);
    });
    native.hidden = true;
    const nativeLabel = form.querySelector('label[for="' + native.id + '"]');
    if (nativeLabel) nativeLabel.hidden = true;
    picker.hidden = false;
    picker.dataset.ready = 'true';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();